import type { Signal } from '@whaletail/signal-engine';
import styles from './Btc15Details.module.css';

export function Btc15Details({
  signal,
  reasonsToSkip,
}: {
  signal: Signal;
  reasonsToSkip: string[];
}) {
  const directionReasons = signal.action === 'UP' ? signal.bull : signal.bear;

  return (
    <details className={styles.details}>
      <summary className={styles.summary}>Full model details</summary>
      <div className={styles.body}>
        <div className={styles.grid}>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Regime</span>
            <span className={styles.metricValue}>{signal.regime}</span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Timeframe trend</span>
            <span className={styles.metricValue}>{signal.trendKey}</span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>RSI</span>
            <span className={styles.metricValue}>{signal.rsi.toFixed(0)}</span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Volume</span>
            <span className={styles.metricValue}>
              {signal.volumeRatio.toFixed(2)}x baseline
            </span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Book pressure</span>
            <span className={styles.metricValue}>
              {(signal.bookImbalance * 100).toFixed(0)}%
              {signal.bookPersistent ? ' (persistent)' : ''}
            </span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Raw score</span>
            <span className={styles.metricValue}>{signal.rawScore.toFixed(1)}</span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>ATR%</span>
            <span className={styles.metricValue}>{signal.atrPct.toFixed(3)}%</span>
          </div>
          <div className={styles.metric}>
            <span className={styles.metricLabel}>Spread</span>
            <span className={styles.metricValue}>{signal.spreadBps.toFixed(2)} bps</span>
          </div>
        </div>

        <div>
          <p className={styles.sectionLabel}>Why {signal.action}</p>
          {directionReasons.length > 0 ? (
            <ul
              className={`${styles.list} ${signal.action === 'UP' ? styles.bull : styles.bear}`}
            >
              {directionReasons.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          ) : (
            <p className={styles.metricValue}>No strong directional reasons.</p>
          )}
        </div>

        {signal.warn.length > 0 && (
          <div>
            <p className={styles.sectionLabel}>Watch</p>
            <ul className={`${styles.list} ${styles.warn}`}>
              {signal.warn.map((warning) => (
                <li key={warning}>{warning}</li>
              ))}
            </ul>
          </div>
        )}

        {reasonsToSkip.length > 0 && (
          <div>
            <p className={styles.sectionLabel}>Why SKIP</p>
            <ul className={styles.list}>
              {reasonsToSkip.map((reason) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </details>
  );
}
